{
  "name": "experian-logon-portal",
  "version": "2.7.0",
  "scripts": {
    "prepare": "npx husky install",
    "ng": "ng",
    "start": "ng serve",
    "start:stg": "ng serve --configuration=dev",
    "build": "ng build --aot --output-hashing=all",
    "watch": "ng build --watch --configuration dev",
    "test": "ng test --code-coverage",
    "test:local": "ng test --code-coverage --karma-config=karma.conf-local.js  --browsers=Chrome_without_background_throttle",
    "test:deploy": "ng test --code-coverage --no-watch --browsers=ChromeHeadless",
    "generate:changelog": "conventional-changelog -p angular -i CHANGELOG.md -s -r 0",
    "release:minor": "standard-version --release-as minor  && exit 0",
    "release:patch": "standard-version --release-as patch  && exit 0",
    "release:major": "standard-version --release-as major  && exit 0",
    "lint": "npm run ng lint",
    "_precommit": "npm run release:patch",
    "commit": "git add -A . && npx git-cz",
    "compodoc:build": "compodoc -p tsconfig.doc.json",
    "compodoc:build-and-serve": "compodoc -p tsconfig.doc.json -s",
    "compodoc:serve": "compodoc -s",
    "mock:start": "json-server --watch ./mocks/mock.js",
    "_preinstall": "npx npm-force-resolutions@0.0.10",
    "biome:format": "biome format --write ."
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.2.18",
    "@angular/cdk": "^19.2.19",
    "@angular/common": "^19.2.18",
    "@angular/compiler": "^19.2.18",
    "@angular/core": "^19.2.18",
    "@angular/forms": "^19.2.18",
    "@angular/material": "^19.2.19",
    "@angular/platform-browser": "^19.2.18",
    "@angular/platform-browser-dynamic": "^19.2.18",
    "@angular/router": "^19.2.18",
    "@auth0/angular-jwt": "^5.1.2",
    "@datadog/browser-rum": "^6.18.1",
    "@ngneat/cashew": "^4.1.0",
    "experian-change-app-components": "1.2.3",
    "experian-design-system": "~19.0.2",
    "experian-renew-frontend-components": "^1.1.2",
    "material-icons": "^1.13.2",
    "ngx-countdown": "^15.0.0",
    "ngx-guided-tour": "^2.0.1",
    "ngx-mask": "^19.0.6",
    "rxjs": "^7.8.1",
    "tslib": "^2.8.1",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.19",
    "@angular-eslint/builder": "^19.8.1",
    "@angular-eslint/eslint-plugin": "^19.8.1",
    "@angular-eslint/eslint-plugin-template": "^19.8.1",
    "@angular-eslint/schematics": "^19.8.1",
    "@angular-eslint/template-parser": "^19.8.1",
    "@angular/cli": "^19.2.19",
    "@angular/compiler-cli": "^19.2.18",
    "@biomejs/biome": "1.7.3",
    "@commitlint/cli": "^17.4.2",
    "@commitlint/config-conventional": "^17.4.2",
    "@compodoc/compodoc": "^1.1.21",
    "@ngrx/effects": "^19.2.1",
    "@ngrx/store": "^19.2.1",
    "@ngrx/store-devtools": "^19.2.1",
    "@types/jasmine": "^2.6.4",
    "@types/node": "22.19.1",
    "@typescript-eslint/eslint-plugin": "^7.11.0",
    "@typescript-eslint/parser": "^7.11.0",
    "commitizen": "^4.3.0",
    "cz-conventional-changelog": "^3.3.0",
    "eslint": "^8.17.0",
    "eslint-plugin-ngrx": "^2.0.0",
    "husky": "^6.0.0",
    "jasmine-core": "^5.5.0",
    "json-server": "^0.17.1",
    "karma": "~6.3.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "standard-version": "^9.1.0",
    "typescript": "^5.5.4"
  },
  "resolutions": {
    "tough-cookie": "4.1.3",
    "word-wrap": "1.2.5",
    "cross-spawn": "7.0.6"
  },
  "overrides": {
    "@types/node": "22.19.1",
    "@typescript-eslint/types": "8.48.1"
  },
  "config": {
    "commitizen": {
      "path": "./node_modules/cz-conventional-changelog"
    }
  }
}
